import { Typography } from '@mui/material';
import { FormattedMessage, useIntl } from 'react-intl';
import { tbColors } from 'styles/colors/tbColors';
import { BenchmarkingFeatureCard } from 'pages/BenchmarkingTeaser/components/BenchmarkingFeatureCard';
import { proBadge } from 'components/Sidebar/NavItems';

export function BenchmarkingTeaser() {
  const intl = useIntl();
  const isDe = intl.locale.toLowerCase().startsWith('de');

  const features: { id: string; icon: 'expansion' | 'growth' | 'trends'; name: string }[] = [
    { id: '1', icon: 'expansion', name: 'expansion' },
    { id: '2', icon: 'growth', name: 'growth' },
    { id: '3', icon: 'trends', name: 'trends' },
  ];
  const highlight = (chunks: React.ReactNode) => <span style={{ color: tbColors.all.turquoise[500] }}>{chunks}</span>;

  return (
    <div className="mb-12 2xl:mb-16 flex flex-col justify-center items-center">
      <div className={'w-full flex justify-between p-4 border-b border-snow-200'}>
        <div className="flex items-center gap-2">
          <img src="/tradebyte/tb360/tb-360-icon.svg" alt="TB.360" className="w-8 h-10" />
          <div className="flex gap-1">
            <span className="text-ash-900 font-bold text-2xl">TB.360</span>
            <div className="self-start">{proBadge}</div>
          </div>
        </div>
      </div>
      <div className="px-10">
        <div className="2p-6 space-y-6 pt-12">
          <div className={'text-ash-900 font-bold text-2xl flex flex-col gap-2'}>
            <div>
              <Typography
                variant="h4"
                sx={{
                  fontFamily: 'Figtree',
                  fontWeight: 800,
                  fontSize: '24px',
                  color: tbColors.all.ash[900],
                  mb: 0,
                  whiteSpace: 'pre-line',
                }}
              >
                <FormattedMessage id="benchmarking.teaser.headline" values={{ highlight }} />
              </Typography>
            </div>
          </div>
          <div>
            <div className="grid grid-cols-6 xl:grid-cols-12 gap-4">
              {features.map((item, index) => (
                <BenchmarkingFeatureCard
                  key={index}
                  icon={item.icon}
                  titleId={`benchmarking.teaser.container${index + 1}.title`}
                  textId={`benchmarking.teaser.container${index + 1}.text`}
                  imagePath={`/images/${item.name}-${isDe ? 'de' : 'en'}.svg`}
                />
              ))}
            </div>
          </div>
          <div className="mt-10 flex justify-end items-center p-8 2xl:p-14 bg-snow-50 w-full gap-4 border-t border-snow-200">
            <p className="font-semibold">
              <FormattedMessage
                id="benchmarking.teaser.cta.question"
                defaultMessage="Do you want to explore Benchmarking?"
              />
            </p>
            <p className="font-semibold">
              <FormattedMessage id="benchmarking.teaser.cta.contact" defaultMessage="Contact your CSM Manager" />
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
